export function useCopyObject(object) {
	return JSON.parse(JSON.stringify(object))
}
